import React from "react";
import { makeStyles } from "@mui/styles";
import { Box, Button, Typography } from "@mui/material";
import ModalContainer from "components/ModalContainer";
import ModalLayout from "components/ModalLayout";
import { SimpleSelectInput } from "components/FormSelectInput";
import { SimpleTextInput } from "components/FormTextInput";
import Table from "components/Table";
import sessionHelper from "services/sessionHelper";
import { SimpleTextareaInput } from "components/FormTextArea";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
  modalConatiner: {
    height: "100%",
    width: "100%",
    margin: "5px",
    display: "flex",
    flexDirection: "column",
    gap: "5px",
  },
  tableContainer: {
    marginTop: "20px",
  },
  iconButton: {
    backgroundColor: "#150A28",
    color: "#FFFFFF",
    borderRadius: 8,
    padding: 8,
    "&:hover": {
      backgroundColor: "#2D1B48",
    },
  },
}));

function RowActions({ rowId, data, actionHandlers }) {
  const styles = useStyles();
  return (
    <Box style={{ display: "flex", gap: "5px" }}>
      <EditIcon
        sx={{ fontSize: 12 }}
        className={styles.iconButton}
        onClick={() => actionHandlers?.handleLangEditClick(data)}
      />
      <DeleteIcon
        sx={{ fontSize: 12 }}
        onClick={() => actionHandlers?.handleLangDeleteClick(data)}
        className={styles.iconButton}
      />
    </Box>
  );
}

function ViewLanguageModal({
  isMultiline = false,
  actions = null,
  isOpen,
  label,
  close,
  onChange,
  modalData,
  tableColumns,
  handleOnSubmit,
  actionHandlers,
}) {
  const styles = useStyles();
  return (
    isOpen && (
      <ModalContainer openModel={isOpen} handleClose={close}>
        <ModalLayout>
          {modalData?.modal === "add" ? (
            <Box className={styles.modalConatiner}>
              <Typography>{label}</Typography>
              <SimpleSelectInput
                label="Language"
                name="language"
                value={modalData.language}
                options={sessionHelper.languageOptions}
                onChange={onChange}
              />
              {isMultiline ? (
                <SimpleTextareaInput
                  label="Translation Content"
                  name="inputValue"
                  value={modalData.inputValue}
                  onChange={onChange}
                />
              ) : (
                <SimpleTextInput
                  label="Translation Content"
                  name="inputValue"
                  value={modalData.inputValue}
                  onChange={onChange}
                />
              )}
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={handleOnSubmit}
              >
                Add
              </Button>
            </Box>
          ) : (
            <Box className={styles.tableContainer}>
              <Table
                data={modalData.viewData}
                columns={tableColumns}
                actions={actions ? actions : RowActions}
                actionHandlers={actionHandlers}
              />
            </Box>
          )}
        </ModalLayout>
      </ModalContainer>
    )
  );
}

ViewLanguageModal.propTypes = {
  isMultiline: PropTypes.bool,
  actions: PropTypes.any,
  isOpen: PropTypes.bool,
  label: PropTypes.string,
  close: PropTypes.func,
  onChange: PropTypes.func,
  modalData: PropTypes.any,
  tableColumns: PropTypes.array,
  handleOnSubmit: PropTypes.any,
  handleLangEditClick: PropTypes.any,
};

export default ViewLanguageModal;
